import DataTableV2ItemView from '@/agilis/components/DataTableV2/DataTableV2ItemView/DataTableV2ItemView.js'
import Configuration from '@/agilis/util/Configuration'
import { mapGetters } from 'vuex'

export default {
  name: 'PriceItemTableView',
  mixins: [DataTableV2ItemView],

  computed: {
    ...mapGetters({
      applicationId: 'contextStore/applicationId',
      trackerTypeId: 'contextStore/trackerTypeId'
    }),

    computedSubtitle () {
      return this.$t('sales.label.priceItem') + ' ' + this.trackerId
    },

    computedTitle () {
      const priceListId = this.itemDTO.priceListId || this.$parent.$parent.priceListId
      const trackerType = Configuration.getTrackerType(this.applicationId, this.trackerTypeId)

      const priceListConfig = trackerType?.priceList[priceListId]
      return priceListConfig && (this.$t('sales.label.priceList') + ': ' + this.$t(priceListConfig.name))
    }
  }

}
